import { createQueryKeys } from '@lukemorales/query-key-factory';

import type { FetchFitnessScoreArgs } from '../api/types/statsInsights.types';

import { fetchFitnessScore } from '../api/fitnessScore.api';

export const statsFitnessScoreQueryKeys = createQueryKeys('statsFitnessScore', {
  fetchFitnessScore: (args: FetchFitnessScoreArgs = {}) => ({
    queryFn: () => fetchFitnessScore(args),
    queryKey: [args],
  }),
});
